export const homePageTypingText: Array<string> = [
  "Stay Hungry, Stay Foolish",
  "求知若飢，虛心若愚",
];
